import apiClient from "../../../../utils/interceptor";
import { API_URLS } from "../../../../constants";

// Get users by company & yard
export const getUsers = async (companyId, yardId) => {
    try {
        const response = await apiClient.get(
            `${API_URLS.USER.GET_USERS}/${companyId}/${yardId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const getManagers = async (companyId, yardId) => {
    try {
        const response = await apiClient.get(
            `${API_URLS.USER.GET_MANAGERS}/${companyId}/${yardId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching managers:", error);
        throw error;
    }
};

// Create user
export const createUser = async (userParams) => {
    try {
        const response = await apiClient.post(
            API_URLS.USER.CREATE_USER,
            userParams
        );
        return response.data;
    } catch (error) {
        console.error("Error creating user:", error);
        throw error;
    }
};

// Update user
export const updateUser = async (userData) => {
    try {
        const response = await apiClient.patch(
            API_URLS.USER.UPDATE_USER,
            userData
        );
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error);
        throw error;
    }
};

// Delete user
export const deleteUser = async (userId) => {
    try {
        const response = await apiClient.delete(
            API_URLS.USER.DELETE_USER,
            {
                data: { user_id: userId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
    }
};

export const getRoleNames = async () => {
    try {
        const response = await apiClient.get(API_URLS.ROLE.GET_ROLE_NAMES);
        return response.data;
    } catch (error) {
        console.error("Error fetching role names:", error);
        throw error;
    }
};

// Update user status (active/inactive)
export const updateUserStatus = async (statusData) => {
    try {
        const response = await apiClient.patch(
            API_URLS.USER.UPDATE_USER_STATUS,
            statusData
        );
        return response.data;
    } catch (error) {
        console.error("Error updating user status:", error);
        throw error;
    }
};
